import { useState, useContext, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import axiosInstance from "../../axiosInstance";

import "./Navigation.css";

import Navbar from "react-bootstrap/Navbar";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import FormControl from "react-bootstrap/FormControl";
import InputGroup from "react-bootstrap/InputGroup";
import NavDropdown from "react-bootstrap/NavDropdown";
import Dropdown from "react-bootstrap/Dropdown";
import Badge from "react-bootstrap/Badge";

import LogoutModal from "./LogoutModal";
import ThemeToggler from "../ThemeToggler";
import { ThemeContext } from "../ThemeProvider";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faPlusCircle,
  faSignOutAlt,
  faUserCircle,
  faVideo,
  faCog,
  faSearch,
  faCopy,
} from "@fortawesome/free-solid-svg-icons";

const Navigation = ({ props }) => {
  const { darkMode } = useContext(ThemeContext);
  const [show, setShow] = useState(false);
  const [fullName, setFullName] = useState("User");
  const [uuid, setUuid] = useState("");
  const [copied, setCopied] = useState(false);
  const history = useHistory();

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      axiosInstance
        .get("/users/currentUser", {
          headers: {
            Authorization: token,
          },
        })
        .then((response) => {
          if (response.data && response.data.success) {
            const { firstName, lastName, uuid } = response.data.data.user;
            setFullName(`${firstName} ${lastName}`);
            setUuid(uuid);
          } else {
            console.error("Failed to fetch user details");
          }
        })
        .catch((error) => {
          console.error("Error fetching user details:", error);
        });
    }
  }, []);

  const handleCopyUUID = () => {
    navigator.clipboard.writeText(uuid);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500); // Reset after 2 seconds
  };

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleLogout = (e) => {
    e.preventDefault();
    localStorage.removeItem("token");
    handleClose();
    history.push("/auth/login");
  };

  const handleMenuToggle = () => {
    props.setShowMenu(!props.showMenu);
  };

  return (
    <>
      <Navbar bg="white" sticky="top" className="osahan-nav" style={{ zIndex: "9999" }}>
        &nbsp;&nbsp;
        <Button
          variant="link"
          size="sm"
          className="order-1 order-sm-0 text-secondary"
          id="sidebarToggle"
          onClick={handleMenuToggle}
        >
          <FontAwesomeIcon icon={faBars} />
        </Button>
        <div className="text-left log_mn_lg">
          <img src="/img/logo-autotrak.png" className="img-fluid" alt="LOGO" />
        </div>
        &nbsp;&nbsp;

        <Form inline className="srcht d-none d-md-inline ml-auto my-2 my-md-0 osahan-navbar-search">
          <InputGroup>
            <FormControl type="text" placeholder="Search for..." className="" />
            <InputGroup.Append>
              <Button variant="light">
                <FontAwesomeIcon icon={faSearch} />
              </Button>
            </InputGroup.Append>
          </InputGroup>
        </Form>

        <ul className="navbar-nav ml-auto ml-md-0 osahan-right-navbar">
          <li className="nav-item mx-1">
            <ThemeToggler />
          </li>

          <NavDropdown
            title={
              <>
                <img
                  src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTUVUH27sngAnS6SnsRdfbuX7XISzFxw-ZVVVgpUWkTBA&s"
                  alt="Avatar"
                />
                <span className="d-none d-md-inline"> {fullName}</span>
              </>
            }
            id=""
            className="no-arrow osahan-right-navbar-user user-dropdown-link"
          >
            <Link to="#" className="dropdown-item" role="button" onClick={handleCopyUUID}>
              <FontAwesomeIcon icon={faCopy} fixedWidth /> ID: {uuid}{" "}
              {copied && <span style={{ color: "#F22E3E", fontSize: "12px" , fontWeight: "600" }}>Copied!</span>}
            </Link>

            <Link to="/account" className="dropdown-item hdt" role="button">
              <FontAwesomeIcon icon={faUserCircle} fixedWidth /> My Account
            </Link>

            <Link to="/subscriptions" className="dropdown-item hdt" role="button">
              <FontAwesomeIcon icon={faVideo} fixedWidth /> Subscriptions
            </Link>

            <Link to="/settings" className="dropdown-item" role="button">
              <FontAwesomeIcon icon={faCog} fixedWidth /> Settings
            </Link>

            <Dropdown.Divider />

            <Link to="#" onClick={handleShow} className="dropdown-item" role="button">
              <FontAwesomeIcon icon={faSignOutAlt} fixedWidth /> Log out
            </Link>
          </NavDropdown>
        </ul>
      </Navbar>

      <LogoutModal show={show} handleClose={handleClose} handleLogout={handleLogout} />
    </>
  );
};

export default Navigation;
